import { Component, Input, HostListener, ViewChild, ElementRef } from '@angular/core';

import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { RunService } from '../../../../services/run.service';
import { TimerService } from '../../../../services/timer.service';
import { Events, LoadingController, ModalController, NavController, PopoverController, ToastController, ViewController } from 'ionic-angular';
import { AlertMessager } from '../../../../lib/alertMessager';
import { LeaderGenerator } from '../../../../lib/leaderGenerator';
import { JudgeService } from '../../../../services/judge.service';
import { Judge, JudgeCategory, JudgeScore } from '../../../../model/judge';
import { JudgeScoresPage } from './judge-scores';
import { BarrelSplitRun } from '../../../../model/barrel-split-run';
import { RunDisplayHelper } from '../../../../lib/run-display-helper';
import { StockSwapPage } from './stock-swap.component';
import { AccountHelper } from '../../../../lib/accountHelper';
import { PayoutConfig } from 'model/payoutConfig';
import { AnnouncerSheetsReport } from '../reports/report-announcer-sheets';
import { ShowSheetsReport } from '../reports/report-show-sheets';
import { BarrelSplitTimeRun, FarmtekReader } from '../../../../lib/farmtek-reader';
import { TimerPromptPage } from './timer-prompt';
import { RodeoService } from '../../../../services/rodeo.service';

@Component({
    selector: 'staff-scoring',
    templateUrl: 'scoring.html'
})
export class ScoringSection {
    @ViewChild('runContainer') runContainer: ElementRef;
    _rodeo: Rodeo;

    schedules: RodeoEventSchedule[] = [];

    possibleRodeoEvents: RodeoEvent[] = [];

    announcerMode: boolean = false;
    followAccountId: string = '';

    timerUrl: string = "http://localhost/nextgen/";
    timerErrorMessage: string;

    popoverActive: boolean;
    connected: boolean;
    startedTimers: boolean;
    stopTimers: boolean;

    timerTimeId: any;
    timerTime: any;
    timerScoreId: any;
    timerScore: any;
    lastReceived: any;
    lastBarrelSplitRunReceived: any;

    selectedRodeoEvent: RodeoEvent;
    selectedSchedule: RodeoEventSchedule;
    selectedRound: number = 1;
    selectedRotation: number = 1;
    selectedRun: RodeoEventRun;
    lastRunSelected: RodeoEventRun;
    scheduleRuns: RodeoEventRun[];
    scheduleRunsLeft: number;

    roundArray: number[] = [];
    rotationArray: number[] = [];
    leaderMode: PayoutConfig;
    leaderModes: PayoutConfig[] = [];

    castingRodeoEvent: RodeoEvent = new RodeoEvent();
    selectedCastingRound: string = "1";
    cleanRunDelay: number = 5;
    pendingSelectedRun: RodeoEventRun;

    displayRun: RodeoEventRun;

    _clockRunning: boolean = false;
    _clockStartTime: number = 0;
    _clockTime: string = "0";

    allLeaders: Map<number, any[]>;

    barrelSplitRuns: any[] = [];

    lastNumber: number = 1;
    judgeConfig: { judges: Judge[], categories: JudgeCategory[], scoresHash?: { [key: number]: { totals: { [key: string]: number }, scores: JudgeScore[] } } };
    disqualified: any[];

    fastestBarrelSplitRun: BarrelSplitRun = null;

    runDisplayHelper: RunDisplayHelper = RunDisplayHelper.instance();
    timerConnected: boolean = false;
    stopDirectFarmTekCommunication: boolean = true;

    @Input()
    set rodeo(rodeo: Rodeo) {
        if (rodeo != null) {
            this._rodeo = rodeo;

            if (this.selectedRodeoEvent == null || !this._rodeo.rodeoEvents.some(x => x.id == this.selectedRodeoEvent.id)) {
                this.selectedRodeoEvent = null;
                this.selectedSchedule = null;
                this.castingRodeoEvent = new RodeoEvent();
                this.castingRodeoEvent.id = -1;
                this.selectedRound = 1;
            }

            this.selectedRun = null;
            this.schedules = [];
            this.scheduleRuns = [];

            this._rodeo.rodeoEvents.forEach((rodeoEvent) => {
                if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding'
                    || rodeoEvent.eventType === 'BarebackRiding')
                    rodeoEvent.roughStock = true;

                rodeoEvent.schedules.forEach(schedule => {
                    if (this.schedules.filter(x => x.name === schedule.name).length == 0)
                        this.schedules.push(schedule);

                    schedule.runs.forEach(run => {
                        this.setDisplayValue(rodeoEvent, run);
                    })
                });
            });

            this.schedules.sort((a, b) => {
                let aDate = new Date(a.scheduledDate);
                let bDate = new Date(b.scheduledDate);

                return aDate > bDate ? 1 : aDate < bDate ? -1 : 0;
            });

            if (this.schedules.length > 0) {
                if (this.selectedSchedule == null || !this.schedules.some(x => x.id == this.selectedSchedule.id))
                    this.selectedSchedule = this.schedules[0];

                this.changedSchedule();
            }
        }
    }
    get rodeo(): Rodeo {
        return this._rodeo;
    }

    constructor(private runService: RunService, private events: Events, private alertMessager: AlertMessager,
        private viewController: ViewController, private timerService: TimerService, private elementRef: ElementRef,
        private judgeService: JudgeService, private modalCtrl: ModalController, private popoverController: PopoverController,
        private loadingController: LoadingController, private rodeoService: RodeoService, private nav: NavController,
        private toast: ToastController, private farmtekReader: FarmtekReader) {
        this.events.subscribe('RunAdded', (data) => this.runsAdded(data));
        this.events.subscribe('RunUpdated', (data) => this.runsUpdated(data));
        this.events.subscribe('RunDeleted', (data) => this.runsDeleted(data));
        this.events.subscribe('TimeUpdated', (data) => this.updateFinalTime(data));
    }

    startTimers() {
        if (this.startedTimers)
            return;

        this.getJudges();
        this.getSelectedRun();
        this.getRunningClock();
        this.changeSelectedRound();
        this.changeSelectedRotation();
        this.updateLeaders();
        this.startedTimers = true;
    }

    showTimerPrompt() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.popoverActive = true;
        let timerModal = this.modalCtrl.create(TimerPromptPage, {}, { cssClass: 'page-judge-scores', enableBackdropDismiss: true });

        timerModal.present().then((data) => {
            this.popoverActive = false;
        })

        timerModal.onDidDismiss((data) => {
            if (data) {
                if (data.rodeoLive) {
                    this.stopDirectFarmTekCommunication = true;

                    this.readRodeoLive();
                } else {
                    this.stopDirectFarmTekCommunication = false;
                    this.showComPorts(data.baudRate);
                }
            }
        });
    }

    readRodeoLive() {
        this.timerConnected = true;

        if (this.selectedRodeoEvent.eventType == 'BarrelRacing') {
            this.timerService.getBarrelSplitRun(this.timerUrl)
                .then(data => {
                    if (data) {
                        this.farmtekReader.barrelSplitTimeRun = new BarrelSplitTimeRun();
                        this.farmtekReader.barrelSplitTimeRun.straightOneSplit = data.straightOneSplit;
                        this.farmtekReader.barrelSplitTimeRun.aroundBarrelOneSplit = data.aroundBarrelOneSplit;
                        this.farmtekReader.barrelSplitTimeRun.straightTwoSplit = data.straightTwoSplit;
                        this.farmtekReader.barrelSplitTimeRun.aroundBarrelTwoSplit = data.aroundBarrelTwoSplit;
                        this.farmtekReader.barrelSplitTimeRun.straightThreeSplit = data.straightThreeSplit;
                        this.farmtekReader.barrelSplitTimeRun.aroundBarrelThreeSplit = data.aroundBarrelThreeSplit;
                        this.farmtekReader.barrelSplitTimeRun.straightFourSplit = data.straightFourSplit;
                        this.farmtekReader.barrelSplitTimeRun.goingLeft = data.goingLeft;
                        this.farmtekReader.barrelSplitTimeRun = data;
                    }
                });
        }

        this.timerService.getTimedRun(this.timerUrl)
            .then(data => {
                this.timerErrorMessage = null;

                if (this.timerTimeId != (data as any).id) {
                    this.timerTimeId = (data as any).id;
                    this.timerTime = (data as any).display;

                    if (this.timerTime && this.selectedRun && this.timerTime != this.lastReceived) {
                        this.farmtekReader.showTime(this.timerTime);
                        this.updateFinalTime();
                    }
                }

                this.connected = true;
                setTimeout(() => {
                    this.readRodeoLive();
                }, 100); (false);
            },
                error => {
                    this.timerConnected = false;
                });
    }

    async showComPorts(baudRate) {
        if ("serial" in navigator) {
            try {
                const port = await (navigator as any).serial.requestPort();
                this.processTimerData(port, baudRate);
            }
            catch (e) {
                this.alertMessager.showError("FarmTek Connection Error", e);
            }
            finally {
                this.timerConnected = false;
            }
        } else {
            console.log('SERIAL NOT SUPPORTED');
            this.timerConnected = false;
        }
    }

    async processTimerData(port, baudRate) {
        try {
            await port.open({ baudRate: +baudRate });
        }
        catch (e) {
            this.alertMessager.showError("FarmTek Connection Error", "Please unplug your USB cord and plug it back into the USB port.");
        }

        this.timerConnected = true;

        var allData: string = "";
        // @ts-ignore
        const decoder = new TextDecoder();

        while (port.readable) {
            const reader = port.readable.getReader();
            this.stopTimers = false;

            try {
                while (true) {
                    const { value, done } = await reader.read();
                    if (done || this.stopDirectFarmTekCommunication) {
                        break;
                    }

                    if (value) {
                        allData += decoder.decode(value);

                        var endIndex = allData.indexOf("\r");

                        if (endIndex > -1) {
                            try {
                                while (allData.split("\r").length - 1 > 1)
                                    allData = allData.substring(allData.indexOf("\r") + 1);

                                if (allData.indexOf("\r") > 0) {
                                    var code = allData.indexOf("\r") != -1 ? 42100000 : 0;
                                    var lastIndex = allData.indexOf("\r") != -1 ? allData.indexOf("\r") : allData.length - 1;
                                    var lastCompleteData = allData.substring(0, lastIndex);
                                    lastCompleteData = lastCompleteData.replace("\"", "");
                                    if (code == 42100000 && lastCompleteData.trim().length > 0) {
                                        this.farmtekReader.handleScoreboardData(lastCompleteData);
                                        this.updateFinalTime();
                                    }
                                    allData = allData.substring(lastCompleteData.length);
                                }
                            }
                            catch (error) {
                                console.log('error: ' + error);
                            }
                        }
                    }
                }
            } catch (error) {
                console.log("error ", error);
            } finally {
                reader.releaseLock();
            }
        }

        this.timerConnected = false;
        port.close();
    }

    stopTimerLoops() {
        this.stopTimers = true;
        this.startedTimers = false;
        this.events.unsubscribe('RunAdded', (data) => this.runsAdded(data));
        this.events.unsubscribe('RunUpdated', (data) => this.runsUpdated(data));
        this.events.unsubscribe('RunDeleted', (data) => this.runsDeleted(data));
        this.events.unsubscribe('TimeUpdated', (data) => this.updateFinalTime(data));
    }

    updateRunSplitData() {
        this.selectedRun.straightOneSplit = this.barrelSplitRuns[this.selectedRun.runIdentifier][0].Time;
        this.selectedRun.aroundBarrelOneSplit = this.barrelSplitRuns[this.selectedRun.runIdentifier][1].Time;
        this.selectedRun.straightTwoSplit = this.barrelSplitRuns[this.selectedRun.runIdentifier][2].Time;
        this.selectedRun.aroundBarrelTwoSplit = this.barrelSplitRuns[this.selectedRun.runIdentifier][3].Time;
        this.selectedRun.straightThreeSplit = this.barrelSplitRuns[this.selectedRun.runIdentifier][4].Time;
        this.selectedRun.aroundBarrelThreeSplit = this.barrelSplitRuns[this.selectedRun.runIdentifier][5].Time;
        this.selectedRun.straightFourSplit = this.barrelSplitRuns[this.selectedRun.runIdentifier][6].Time;

        this.runService.addSplitRunData([this.selectedRun])
            .then((data) => {
                if ((data as any).message !== undefined) {
                    this.alertMessager.showError("Update Error", (data as any).message);
                } else {
                    setTimeout(() => {
                        this.nextRun();
                    }, 350);
                }
            });
    }

    runsUpdated(updated) {
        updated.forEach(run => {
            let foundRun = false;
            for (let i = 0; i < this.rodeo.rodeoEvents.length; i++) {
                for (let x = 0; x < this.rodeo.rodeoEvents[i].schedules.length; x++) {
                    if (this.rodeo.rodeoEvents[i].schedules[x].id != run.rodeoEventScheduleId)
                        continue;

                    if (run.id == this.displayRun.id) {
                        this.setDisplayRun(run);
                    }

                    for (let y = 0; y < this.scheduleRuns.length; y++) {
                        if (this.scheduleRuns[y].id == run.id) {
                            if (run.id == this.displayRun.id) {
                                this.setDisplayValue(this.rodeo.rodeoEvents[i], run);
                                this.setDisplayRun(run);
                            }

                            Object.assign(this.scheduleRuns[y], run);
                            foundRun = true;
                            break;
                        }
                    }

                    if (foundRun)
                        break;
                }

                if (foundRun)
                    break;
            }
        });

        if (updated.length > 0) {
            this.setScheduleRuns();

            if (this.scheduleRuns.length == 0) {
                //console.log('runsUpdated resetting round');
                this.selectedRound = 1;
                this.setScheduleRuns();
            }

            this.reSortRuns();
            this.updateLeaders();
        }
    }

    runsDeleted(deleted) {
        deleted.forEach(runUpdateInfo => {
            this.scheduleRuns = this.scheduleRuns.filter(x => x.id != runUpdateInfo.id);
        });

        if (deleted.length > 0) {
            this.setScheduleRuns();

            /*
            if (this.scheduleRuns.length == 0) {
                console.log('runsDeleted resetting round');
                this.selectedRound = 1;
                this.setScheduleRuns();
            }
            */

            this.reSortRuns();
            this.updateLeaders();
        }
    }

    runsAdded(added) {
        if (added.length > 0) {
            this.setScheduleRuns();

            if (this.scheduleRuns.length == 0) {
                this.selectedRound = 1;
                this.setScheduleRuns();
            }

            this.reSortRuns();
            this.updateLeaders();
        }
    }

    updateFinalTime(data = null) {
        if (this.stopTimers && !data)
            return;

        if (data)
            this.timerTime = data;

        /* Keep this here, re-assess if we ever use it again.
        if ((this.selectedRodeoEvent.eventType == 'TeamRoping' && this.selectedRodeoEvent.handicapLimit && this.selectedRodeoEvent.handicapLimit > 0) || this.selectedRodeoEvent.eventType == 'ShowTeamRoping') {
            this.timerService.getTimeData(this.timerUrl)
                .then(data => {
                    this.timerErrorMessage = null;

                    if (data && this.timerTimeId != (data as any).id) {
                        this.timerTimeId = (data as any).id;
                        this.timerTime = (data as any).totalTime;

                        if (this.timerTime && this.selectedRun && this.timerTime != this.lastReceived) {
                            if (this.selectedRodeoEvent.configuration.runs.timeValue) {
                                if (!this.selectedRun.done) {
                                    if (this.selectedRodeoEvent.configuration.runs.scoreValue)
                                        this.displayRun.timeDisplayValue = this.timerTime;
                                    else
                                        this.displayRun.displayValue = this.timerTime;

                                    this.displayRun.headerSplit = (data as any).headerSplit;
                                    this.displayRun.heelerSplit = (data as any).heelerSplit;
                                    this.displayRun.breakoutTime = (data as any).breakout;
                                    this.displayRun.barrierOneBreak = (data as any).headerBreak;
                                    this.displayRun.barrierTwoBreak = (data as any).heelerBreak;
                                    this.selectedRun.headerSplit = this.displayRun.headerSplit;
                                    this.selectedRun.heelerSplit = this.displayRun.heelerSplit;
                                    this.selectedRun.breakoutTime = this.displayRun.breakoutTime;
                                    this.selectedRun.barrierOneBreak = this.displayRun.barrierOneBreak;
                                    this.selectedRun.barrierTwoBreak = this.displayRun.barrierTwoBreak;

                                    if (this.displayRun.barrierOneBreak || this.displayRun.barrierTwoBreak) {
                                        this.selectedRun.penaltyTime = +this.selectedRodeoEvent.barrierPenalty;

                                        if (this.selectedRodeoEvent.configuration.runs.scoreValue)
                                            this.displayRun.timeDisplayValue = +this.displayRun.timeDisplayValue + +this.selectedRun.penaltyTime;
                                        else
                                            this.displayRun.displayValue = +this.displayRun.displayValue + +this.selectedRun.penaltyTime;
                                    }

                                    this.lastReceived = this.timerTime;
                                }
                            }
                        }
                    }

                    this.connected = true;
                },
                    error => {
                        this.timerErrorMessage = error;
                    });
        } else {

        FARMTEK TIMER CODE PULLED FROM OLD RODEO LIVE
        THIS REQUIRES Standard Ouput FROM FARMTEK, WHICH IS INCOMPATIBLE WITH ALL OTHER FORMATS
        allData += data;

        if (allData.Count(x => x == '\r') == 2)
        {
            if (allData.StartsWith("Start"))
            {
                allData = allData.Substring(6, allData.Length - 6);

            }

            if (allData.StartsWith("\rBreakout"))
            {
                var dataString = allData.Split('\r')[1];

                int breakoutNumberStart = dataString.IndexOfAny("-0123456789".ToCharArray());
                int breakoutNumberStop = dataString.LastIndexOfAny("0123456789".ToCharArray()) + 1;

                breakoutTime = double.Parse(dataString.Substring(breakoutNumberStart, breakoutNumberStop - breakoutNumberStart));
                var secondReturnIndex = allData.IndexOf('\r', allData.IndexOf("Breakout"));
                allData = "\r" + allData.Substring(secondReturnIndex + 1, allData.Length - (secondReturnIndex + 1));
                receivedBreakoutTime = true;
            }

            if (allData.Count(x => x == '\r') == 2)
            {
                var dataString = allData.Split('\r')[1];

                int headerSplitNumberStart = dataString.IndexOfAny("0123456789".ToCharArray());
                int headerSplitNumberStop = dataString.LastIndexOfAny("0123456789".ToCharArray()) + 1;

                double time = double.Parse(dataString.Substring(headerSplitNumberStart, headerSplitNumberStop - headerSplitNumberStart)) - splitTime;
                string extraData = dataString.Substring(headerSplitNumberStop, dataString.Length - headerSplitNumberStop);

                if (extraData.Contains("S"))
                {
                    splitTime = time;
                    Console.WriteLine("Received Split Time : " + splitTime);
                }
                else
                {
                    manual = extraData.Contains("M");
                    headerBreak = extraData.Contains("HDR");
                    heelerBreak = extraData.Contains("HLR");

                    if (extraData.Contains("H+H"))
                    {
                        headerBreak = true;
                        heelerBreak = true;
                    }

                    Console.WriteLine("Received Total Time : " + time + " Breakout : " + (receivedBreakoutTime ? breakoutTime + "" : "N/A") + " Manual : " + manual + " HeaderBreak : " + headerBreak + " HeelerBreak : " + heelerBreak);

                    try
                    {
                        using (WebClient client = new WebClient())
                        {
                            client.Headers["Content-Type"] = "application/json";
                            client.Headers.Add("Authorization", "ILikeCheese");
                            // ropemetrics-service-centralus.azurewebsites.net

                            byte[] response =
                            client.UploadData("http://ropemetrics-service-centralus.azurewebsites.net/timer/log", "POST", Encoding.Default.GetBytes(
                                "" +
                                "{ Name: \"" + _name + "\"," +
                                "  TotalTime: \"" + (splitTime + time) + "\"," +
                                "  BreakoutTime: \"" + (breakoutTime) + "\"," +
                                "  HeaderSplit: \"" + splitTime + "\"," +
                                "  HeelerSplit: \"" + (splitTime == 0 ? 0 : time) + "\"," +
                                "  HeaderBarrierBreak: \"" + headerBreak.ToString() + "\"," +
                                "  HeelerBarrierBreak: \"" + heelerBreak.ToString() + "\"," +
                                "  Manual: \"" + manual.ToString() + "\"," +
                                " }"));

                            string result = Encoding.UTF8.GetString(response);
                        }
                    }
                    catch (Exception exception)
                    {
                        Console.WriteLine(exception);
                    }
                    finally
                    {
                        splitTime = 0;
                        breakoutTime = 0;
                        receivedBreakoutTime = false;
                    }
                }

                allData = "";
            }
        }
         */
        this.timerTime = this.farmtekReader.getTime();

        if (this.timerTime && this.selectedRun && this.timerTime != this.lastReceived) {
            if (!this.selectedRun.done) {
                if (this.selectedRodeoEvent.configuration.runs.scoreValue)
                    this.displayRun.timeDisplayValue = (+this.timerTime).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
                else
                    this.displayRun.displayValue = (+this.timerTime).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);

                this.lastReceived = (+this.timerTime).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
            }
        }
        //}

        if (this.selectedRodeoEvent.eventType == 'BarrelRacing') {
            const splitRun = this.farmtekReader.getBarrelSplitRun();

            if (splitRun && this.selectedRun && (!this.lastBarrelSplitRunReceived || !this.lastBarrelSplitRunReceived.updated || splitRun.updated > this.lastBarrelSplitRunReceived.updated)) {
                if (this.selectedRodeoEvent.configuration.runs.timeValue) {
                    if (!this.selectedRun.done) {
                        if (this.selectedRodeoEvent.configuration.runs.scoreValue)
                            this.displayRun.timeDisplayValue = (+this.timerTime).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
                        else {
                            this.displayRun.straightOneSplit = +splitRun.straightOneSplit;
                            this.displayRun.aroundBarrelOneSplit = +splitRun.aroundBarrelOneSplit;
                            this.displayRun.straightTwoSplit = +splitRun.straightTwoSplit;
                            this.displayRun.aroundBarrelTwoSplit = +splitRun.aroundBarrelTwoSplit;
                            this.displayRun.straightThreeSplit = +splitRun.straightThreeSplit;
                            this.displayRun.aroundBarrelThreeSplit = +splitRun.aroundBarrelThreeSplit;
                            this.displayRun.straightFourSplit = +splitRun.straightFourSplit;
                            (this.displayRun as any).goingLeft = splitRun.goingLeft;
                        }

                        this.lastBarrelSplitRunReceived = JSON.parse(JSON.stringify(splitRun));

                        this.timerService.setOnlineSelectedRun(this.displayRun, this.rodeo.id)
                            .then(data => {
                                this.timerErrorMessage = null;
                            },
                                error => {
                                    this.timerErrorMessage = error;
                                });
                    }
                }
            }
        }
    }

    onDisplayFocus() {
        let roughStock = this.isRoughStock(this.selectedRodeoEvent);

        if (roughStock) {
            if (!this.displayRun.done && this.displayRun.score == 0)
                this.displayRun.displayValue = '';
        } else {
            if (!this.displayRun.done && this.displayRun.time == 0)
                this.displayRun.displayValue = '';
        }
    }

    onTimeDisplayFocus() {
        if (!this.displayRun.done && this.displayRun.time == 0)
            this.displayRun.timeDisplayValue = '';
    }

    setDisplayRun(run) {
        this.displayRun = run;

        if (run) {
            if (!run.error)
                this.displayRun.error = false;

            (this.displayRun as any).prevRuns = this.rodeo.rodeoEvents.flatMap(x => x.schedules).flatMap(x => x.runs).filter(x => x.id != run.id && x.runIdentifier == run.runIdentifier);

            if (this.selectedRodeoEvent.configuration.runs.scoreValue) {
                (this.displayRun as any).prevRuns = (this.displayRun as any).prevRuns.filter(x => (this.displayRun.startingScore == 0 || x.totalScore <= this.displayRun.startingScore) && x.startingScore != this.displayRun.startingScore);
            } else {
                (this.displayRun as any).prevRuns = (this.displayRun as any).prevRuns.filter(x => (this.displayRun.startingTime == 0 || x.totalTime <= this.displayRun.startingTime) && x.startingTime != this.displayRun.startingTime);
            }

            if ((this.displayRun as any).prevRuns) {
                (this.displayRun as any).prevRuns.sort((a, b) => {
                    if (a.round < b.round)
                        return -1;
                    else
                        return 0;
                });
            }

            (this.displayRun as any).displaySuccessfulRuns = (this.displayRun as any).prevRuns.filter(x => x.done && !x.noTime && !x.turnedOut && !x.turnedOutNotified).length;

            if (this.selectedRodeoEvent.configuration.runs.scoreValue) {
                this.displayRun.displayValue = run.score;
                this.displayRun.timeDisplayValue = run.time;
            } else
                this.displayRun.displayValue = run.time;

            if (this.selectedRodeoEvent.configuration.runs.scoreValue && this.timerScore) {
                this.displayRun.displayValue = this.timerScore;
            }

            if (this.selectedRodeoEvent.configuration.runs.timeValue && this.timerTime) {
                if (this.selectedRodeoEvent.configuration.runs.scoreValue)
                    this.displayRun.timeDisplayValue = this.timerTime;
                else if (!run.done)
                    this.displayRun.displayValue = this.timerTime;
            }

            (this.displayRun as any).prevRuns.forEach(run => {
                run.prevRuns = [];
            });
        }

        if (this.displayRun && this.judgeConfig && this.judgeConfig.scoresHash && this.judgeConfig.scoresHash[this.displayRun.id]) {
            if (this.selectedRodeoEvent.configuration.runs.scoreValue && this.selectedRodeoEvent.configuration.runs.timeValue) {
                this.displayRun.timeDisplayValue = run && run.done ? run.time : this.timerTime;
                this.displayRun.displayValue = +(+this.judgeConfig.scoresHash[this.displayRun.id].totals.total + +this.selectedRodeoEvent.showBaseTime - +this.displayRun.timeDisplayValue).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);

                if (!this.displayRun.timeDisplayValue) {
                    this.displayRun.timeDisplayValue = 0;
                }
            }
        }

        if (!this.displayRun)
            this.displayRun = new RodeoEventRun();

        this.displayRun.penaltyTime = +this.displayRun.penaltyTime.toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
        (this.displayRun as any).barrelSplits = this.barrelSplitRuns[this.displayRun.runIdentifier];
    }

    incrementClock() {
        if (this._clockRunning) {
            this._clockTime = ((new Date().getTime() - this._clockStartTime) / 1000).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);

            if (this.displayRun && !this.displayRun.done) {
                if (this.selectedRodeoEvent.configuration.runs.scoreValue)
                    this.displayRun.timeDisplayValue = this._clockTime;
                else if (this.selectedRodeoEvent.configuration.runs.timeValue)
                    this.displayRun.displayValue = this._clockTime;
            }

            setTimeout(() => {
                this.incrementClock();
            }, 25);
        }
    }

    startClock() {
        this._clockStartTime = new Date().getTime() - 25;
        this.incrementClock();
    }

    getRunningClock() {
        if (this.followAccountId && this.followAccountId != '') {
            this.timerService.getRunningClock(this.rodeo.id, this.followAccountId)
                .then(data => {
                    var wasStopped = this._clockRunning == false;

                    this._clockRunning = (data as any).ClockRunning;
                    if (wasStopped && this._clockRunning)
                        this.startClock();

                    if ((data as any).Time != -1) {
                        this._clockTime = (+(data as any).Time).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);

                        if (this.displayRun && !this.displayRun.done) {
                            if (this.selectedRodeoEvent.configuration.runs.scoreValue)
                                this.displayRun.timeDisplayValue = this._clockTime;
                            else if (this.selectedRodeoEvent.configuration.runs.timeValue)
                                this.displayRun.displayValue = this._clockTime;
                        }
                    }

                    setTimeout(() => {
                        this.getRunningClock();
                    }, 100);
                }, error => {
                    setTimeout(() => {
                        this.getRunningClock();
                    }, 200);
                });
        } else {
            setTimeout(() => {
                this.getRunningClock();
            }, 500);
        }
    }

    getSelectedRun() {
        if (this.announcerMode && this.followAccountId && this.followAccountId != '') {
            this.timerService.getSelectedRun(this.rodeo.id, this.followAccountId)
                .then(data => {
                    if (data) {
                        var run = null;
                        var runId = +data[0].runId;

                        if (!this.selectedRun || this.selectedRun.id != runId) {
                            this.rodeo.rodeoEvents.forEach(rodeoEvent => {
                                rodeoEvent.schedules.forEach(schedule => {
                                    if (run != null)
                                        return;

                                    run = schedule.runs.filter(x => x.id == runId)[0];

                                    if (run != null) {
                                        this.selectedRodeoEvent = rodeoEvent;
                                        this.selectedSchedule = schedule;
                                        this.selectedRound = run.round;
                                        this.changeSelectedRodeoEvent();
                                        return;
                                    }
                                });

                                if (run != null)
                                    return;
                            })

                            this.selectRun(run, false, true);
                        }
                    }

                    setTimeout(() => {
                        this.getSelectedRun();
                    }, 250);
                }, error => {
                    setTimeout(() => {
                        this.getSelectedRun();
                    }, 500);
                });
        } else {
            setTimeout(() => {
                this.getSelectedRun();
            }, 500);
        }
    }

    updateDisplayValue() {
        if (this.displayRun && this.judgeConfig && this.judgeConfig.scoresHash && this.judgeConfig.scoresHash[this.displayRun.id]) {
            if (this.selectedRodeoEvent.configuration.runs.scoreValue) {
                if (this.selectedRodeoEvent.configuration.runs.timeValue)
                    this.displayRun.displayValue = +(+this.judgeConfig.scoresHash[this.displayRun.id].totals.total + +this.selectedRodeoEvent.showBaseTime - +this.displayRun.timeDisplayValue).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
                else
                    this.displayRun.displayValue = +(+this.judgeConfig.scoresHash[this.displayRun.id].totals.total).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
            }
        }
    }

    selectRun(run: RodeoEventRun, delay: boolean, overrideBroadcastCheck: boolean) {
        this.lastRunSelected = this.selectedRun;
        this.setDisplayRun(run);

        this.selectedRun = run;

        let runIndex = this.scheduleRuns.indexOf(this.scheduleRuns.filter(x => x.id == this.selectedRun.id)[0]);

        if (this.runContainer && this.runContainer.nativeElement) {
            if (runIndex > 2) {
                var draglineOffsets = 0;
                var numberToDetermineOffsets = +run.number;

                if (this.selectedRound == 2 || this.selectedRound == 1 && this.scheduleRuns.some(x => x.startingScore != 0 || x.startingTime != 0)) {

                    if (this.selectedRodeoEvent.reverseSecondRound || this.selectedRound == 1 && this.scheduleRuns.some(x => x.startingScore != 0 || x.startingTime != 0))
                        numberToDetermineOffsets = +this.scheduleRuns[0].number - +run.number;

                    if (this.selectedRodeoEvent.reverseSecondRoundDragOnly) {
                        numberToDetermineOffsets -= +run.number % +this.selectedRodeoEvent.dragEvery - Math.floor(+this.selectedRodeoEvent.dragEvery / 2) + 1;
                    }
                }

                if (this.selectedRodeoEvent.eventType == 'BarrelRacing' || this.selectedRodeoEvent.eventType == 'PoleBending') {
                    draglineOffsets = Math.floor(numberToDetermineOffsets / +this.selectedRodeoEvent.dragEvery) * 2;
                    draglineOffsets += Math.floor(numberToDetermineOffsets / +this.selectedRodeoEvent.bigDragEvery) * 6;
                }

                this.runContainer.nativeElement.scrollTop = (runIndex - 2) * 45 + draglineOffsets;
            } else
                this.runContainer.nativeElement.scrollTop = 0;
        }

        if (!this.timerUrl)
            return;

        if (!run.done || overrideBroadcastCheck) {
            this.pendingSelectedRun = run;

            setTimeout(() => {
                this.updateTimerSelectedRun(this.pendingSelectedRun);
            }, delay ? this.cleanRunDelay * 1000 : 0);
        }
    }

    isRoughStock(rodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    publishSelectedSchedule() {
        let loading = this.loadingController.create({
            content: 'Notifying contestants...',
        });

        var message = "Success! ";
        var publishMessage = 'published';
        message += " " + this.selectedSchedule.name + ` has been ${publishMessage} for `;
        message += " " + this.selectedRodeoEvent.displayName;

        loading.present();

        this.rodeoService.sendRunNotifications(this.rodeo.id, this.selectedRodeoEvent.id, this.selectedSchedule.id, true)
            .then((data: any) => {
                loading.dismiss();
                this.popoverActive = false;

                if (data.hasOwnProperty('message')) {
                    this.alertMessager.showError("Run Notification Error", data.message);
                } else {
                    this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
                        if (this.selectedRodeoEvent.id && rodeoEvent.id != this.selectedRodeoEvent.id)
                            return;

                        rodeoEvent.schedules.forEach((schedule) => {
                            if (this.selectedSchedule.id && schedule.name != this.selectedSchedule.name)
                                return;

                            schedule.published = true;
                            schedule.stockPublished = true;
                        })
                    });

                    this.toast.create({
                        message: message,
                        duration: 3000,
                        position: 'bottom'
                    }).present();
                }
            }, error => {
                loading.dismiss();
                this.popoverActive = false;
                console.log("Run Notification Error: ", error)
            });
    }

    printSheet(show: boolean) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        if (show) {
            this.nav.push(ShowSheetsReport, {
                rodeo: this.rodeo,
                print: true,
                shortRound: this.selectedRound > this.selectedRodeoEvent.rounds,
                selectedRodeoEvent: this.selectedRodeoEvent
            }).then(() => { this.popoverActive = false; });
        } else {
            this.nav.push(AnnouncerSheetsReport, {
                rodeo: this.rodeo,
                print: true,
                schedule: this.selectedSchedule,
                selectedRound: this.selectedRound,
                selectedRodeoEvent: this.selectedRodeoEvent
            }).then(() => { this.popoverActive = false; });
        }
    }

    updateLeaders() {
        if (!this.selectedRodeoEvent)
            return;

        this.fastestBarrelSplitRun = new BarrelSplitRun();
        this.leaderModes = this.rodeo.payoutConfigs.filter(x => x.sources.some(y => y.rodeoEventId == this.selectedRodeoEvent.id && (!y.scheduleId || y.scheduleId == this.selectedSchedule.id)));

        if (this.selectedSchedule.scheduleGroupId && this.selectedSchedule.scheduleGroupId != 0) {
            this.rodeo.rodeoEvents.forEach(rodeoEvent => {
                if (rodeoEvent == this.selectedRodeoEvent)
                    return;

                rodeoEvent.schedules.filter(x => x.scheduleGroupId == this.selectedSchedule.scheduleGroupId).forEach(schedule => {
                    this.leaderModes.push(...this.rodeo.payoutConfigs.filter(x => x.sources.some(y => y.rodeoEventId == rodeoEvent.id && (!y.scheduleId || y.scheduleId == schedule.id))));
                })
            })
        }

        this.allLeaders = LeaderGenerator.instance().getAllLeaders(this.rodeo, this.leaderModes);

        if (!this.leaderMode)
            this.leaderMode = this.leaderModes[0];

        var dsLeaderSet = this.leaderModes.filter(x => x.name == 'Ds')[0];
        if (dsLeaderSet) {
            let leaders = this.allLeaders.get(dsLeaderSet.id);

            if (leaders) {
                leaders.forEach(leaderGroup => {
                    leaderGroup.runs.forEach(run => {
                        if (run.straightOneSplit && run.straightOneSplit < this.fastestBarrelSplitRun.straightOneSplit)
                            this.fastestBarrelSplitRun.straightOneSplit = run.straightOneSplit;

                        if (run.aroundBarrelOneSplit && run.aroundBarrelOneSplit < this.fastestBarrelSplitRun.aroundBarrelOneSplit)
                            this.fastestBarrelSplitRun.aroundBarrelOneSplit = run.aroundBarrelOneSplit;

                        if (run.straightTwoSplit && run.straightTwoSplit < this.fastestBarrelSplitRun.straightTwoSplit)
                            this.fastestBarrelSplitRun.straightTwoSplit = run.straightTwoSplit;

                        if (run.aroundBarrelTwoSplit && run.aroundBarrelTwoSplit < this.fastestBarrelSplitRun.aroundBarrelTwoSplit)
                            this.fastestBarrelSplitRun.aroundBarrelTwoSplit = run.aroundBarrelTwoSplit;

                        if (run.straightThreeSplit && run.straightThreeSplit < this.fastestBarrelSplitRun.straightThreeSplit)
                            this.fastestBarrelSplitRun.straightThreeSplit = run.straightThreeSplit;

                        if (run.aroundBarrelThreeSplit && run.aroundBarrelThreeSplit < this.fastestBarrelSplitRun.aroundBarrelThreeSplit)
                            this.fastestBarrelSplitRun.aroundBarrelThreeSplit = run.aroundBarrelThreeSplit;

                        if (run.straightFourSplit && run.straightFourSplit < this.fastestBarrelSplitRun.straightFourSplit)
                            this.fastestBarrelSplitRun.straightFourSplit = run.straightFourSplit;
                    })
                });
            }

        }

        this.updateCastingLeaders(this.leaderMode);
    }

    updateCastingLeaders(leaderMode) {
        this.leaderMode = leaderMode;

        if (this.stopTimers)
            return;

        let castingLeaders = [];
        let singleLeaders = [];
        this.allLeaders.forEach((leaderGroups: any[], key) => {
            var splitMode = this.leaderModes.filter(x => x.name == 'Round 1' || x.name.indexOf('Split') != -1)[0];
            if (this.selectedRodeoEvent.leaderDivisions
                && splitMode && (key == splitMode.id))
                return;

            leaderGroups.forEach((leaderGroup => {
                let newLeaderGroup: any = {};

                newLeaderGroup.eventName = this.selectedRodeoEvent.displayName;
                newLeaderGroup.name = leaderGroup.name;
                newLeaderGroup.runs = [];

                leaderGroup.runs.forEach((run) => {
                    let newRun = Object.assign(Object.create(run), run);

                    if (this.selectedRodeoEvent.configuration.runs.timeValue)
                        newRun.time = this.runDisplayHelper.getRunValue(this.selectedRodeoEvent, run, leaderGroup.mode.isAggregate || leaderGroup.mode.isAverage, true, leaderGroup.mode);
                    else
                        newRun.score = this.runDisplayHelper.getRunValue(this.selectedRodeoEvent, run, leaderGroup.mode.isAggregate || leaderGroup.mode.isAverage, true, leaderGroup.mode);

                    newRun.extraDisplay = (leaderGroup.mode.isAverage || leaderGroup.mode.isAggregate) && run.displaySuccessfulRuns > 0 ? ' on ' + run.displaySuccessfulRuns : '';
                    newLeaderGroup.runs.push(newRun);
                });

                //if (this.selectedRodeoEvent.leaderDivisions && leaderGroup.name)
                castingLeaders.push(newLeaderGroup);

                if (this.leaderMode && key == this.leaderMode.id) {
                    singleLeaders.push(newLeaderGroup);
                }
            }));

        });

        if (singleLeaders.length > 0) {
            this.timerService.setLeaders(this.timerUrl, singleLeaders[0].runs, this.selectedRodeoEvent.displayName, this.selectedRodeoEvent.eventType, false)
                .then(data => {
                    this.timerErrorMessage = null;
                },
                    error => {
                        this.timerErrorMessage = error;
                    });
        }

        if (castingLeaders.length > 0) {
            this.timerService.setGroupLeaders(this.timerUrl, castingLeaders, this.selectedRodeoEvent.eventType, false)
                .then(data => {
                    this.timerErrorMessage = null;
                },
                    error => {
                        this.timerErrorMessage = error;
                    });
        }
    }

    reSortRuns() {
        if (this.selectedRound > this.selectedRodeoEvent.rounds || this.selectedRound == 1 && this.scheduleRuns.some(x => x.startingScore != 0 || x.startingTime != 0)) {
            this.scheduleRuns = this.scheduleRuns
                .sort((a, b) => {
                    if (a.number > b.number)
                        return -1;
                    else
                        return 1;
                });
        } else if (this.selectedRound == 2) {
            if (this.selectedRodeoEvent.reverseSecondRoundDragOnly) {
                this.scheduleRuns = this.scheduleRuns
                    .sort((a, b) => {
                        if (Math.floor((a.number - 1) / this.selectedRodeoEvent.dragEvery) < Math.floor((b.number - 1) / this.selectedRodeoEvent.dragEvery))
                            return -1;
                        else if (Math.floor((a.number - 1) / this.selectedRodeoEvent.dragEvery) > Math.floor((b.number - 1) / this.selectedRodeoEvent.dragEvery))
                            return 1;

                        if (a.number % this.selectedRodeoEvent.dragEvery == 0 && b.number % this.selectedRodeoEvent.dragEvery != 0)
                            return -1;
                        else if (a.number % this.selectedRodeoEvent.dragEvery != 0 && b.number % this.selectedRodeoEvent.dragEvery == 0)
                            return 1;

                        if (a.number % this.selectedRodeoEvent.dragEvery > b.number % this.selectedRodeoEvent.dragEvery)
                            return -1;
                        else if (a.number % this.selectedRodeoEvent.dragEvery < b.number % this.selectedRodeoEvent.dragEvery)
                            return 1;
                        else
                            return 0;
                    });
            } else if (this.selectedRodeoEvent.reverseSecondRound) {
                this.scheduleRuns = this.scheduleRuns
                    .sort((a, b) => {
                        if (a.number > b.number)
                            return -1;
                        else
                            return 1;
                    });
            } else {
                this.scheduleRuns = this.scheduleRuns
                    .sort((a, b) => {
                        if (a.number < b.number)
                            return -1;
                        else
                            return 1;
                    });
            }
        } else {
            this.scheduleRuns = this.scheduleRuns
                .sort((a, b) => {
                    if (a.number < b.number)
                        return -1;
                    else
                        return 1;
                });
        }

        this.scheduleRunsLeft = this.scheduleRuns.filter(x => !x.done).length;
    }

    setScheduleRuns() {
        if (this.selectedSchedule.scheduleGroupId && this.selectedSchedule.scheduleGroupId != 0 && this.selectedRound <= this.selectedRodeoEvent.rounds) {
            this.scheduleRuns = this.rodeo.rodeoEvents.flatMap(x => x.schedules)
                .filter(x => x.scheduleGroupId == this.selectedSchedule.scheduleGroupId).flatMap(x => x.runs)
                .filter(x => x.round == this.selectedRound);
        } else {
            this.scheduleRuns = this.selectedSchedule.runs.filter(x => x.round == this.selectedRound);
        }

        this.scheduleRuns.forEach(run => {
            if (run.rodeoEventScheduleId != this.selectedSchedule.id)
                (run as any).showAsterisk = true;
            else
                (run as any).showAsterisk = false;
        });
    }

    changeSelectedRound() {
        this.setScheduleRuns();
        this.reSortRuns();

        var selectedRun = this.scheduleRuns[0];

        if (this.scheduleRuns && this.scheduleRuns.length > 0) {
            /*
            if (this.selectedRound > this.selectedRodeoEvent.rounds || (this.selectedRound == 2 && this.selectedRodeoEvent.reverseSecondRound)) {
                selectedRun = this.scheduleRuns[this.scheduleRuns.length - 1];
            }
            */

            this.lastNumber = selectedRun.number;
        } else
            this.lastNumber = 0;

        if (selectedRun) {
            this.selectRun(selectedRun, false, false);
        }
    }

    changeSelectedRotation() {
        if (this.selectedRodeoEvent.rotationMax == 0)
            return;

        let startTeamNumber = Math.max(this.selectedRotation - 1, 0) * this.selectedRodeoEvent.rotationMax + 1;
        let lastTeamNumber = this.selectedRotation * this.selectedRodeoEvent.rotationMax;


        this.setScheduleRuns();
        this.scheduleRuns = this.scheduleRuns.filter(x => x.number >= startTeamNumber && x.number <= lastTeamNumber)
        this.reSortRuns();

        if (this.scheduleRuns && this.scheduleRuns.length > 0) {
            this.lastNumber = this.scheduleRuns[0].number;
        } else
            this.lastNumber = 1;
    }

    changeSelectedRodeoEvent() {
        this.selectedSchedule = this.selectedRodeoEvent.schedules.filter(x => x.name === this.selectedSchedule.name)[0];

        if (!this.selectedSchedule) {
            this.selectedSchedule = this.selectedRodeoEvent.schedules[0];
        }

        if (this.scheduleRuns.length == 0) {
            this.selectedRound = 1;
        }

        this.setScheduleRuns();

        if (this.selectedRound >= this.selectedRodeoEvent.rounds && this.selectedRound != this.selectedRodeoEvent.rounds + (this.selectedRodeoEvent.shortGo ? 1 : 0))
            this.selectedRound = this.selectedRodeoEvent.rounds;

        this.roundArray = [];

        for (let i = 1; i <= this.selectedRodeoEvent.rounds + (this.selectedRodeoEvent.shortGo ? 1 : 0); i++) {
            this.roundArray.push(i);
        }

        this.rotationArray = [];

        if (this.selectedRodeoEvent.rotationMax > 0) {
            var lastNumber = Math.max(...this.selectedRodeoEvent.schedules[0].runs.map(x => x.number));
            var rotationNumber = 1;

            while (lastNumber > 0) {
                this.rotationArray.push(rotationNumber);
                lastNumber -= this.selectedRodeoEvent.rotationMax;
                rotationNumber++;
            }

            if (this.selectedRotation >= rotationNumber)
                this.selectedRotation = rotationNumber;
        }

        this.changeSelectedRound();
        this.changeSelectedRotation();

        this.selectedRun = this.scheduleRuns[0];
        this.setDisplayRun(this.scheduleRuns[0]);

        if (!this.displayRun)
            this.displayRun = new RodeoEventRun();

        this.updateLeaders();
    }

    shouldWriteDragLine(run, runIndex) {
        if (this.selectedRodeoEvent.dragEvery == 0 || run == null || runIndex + 1 >= this.scheduleRuns.length)
            return false;

        let nextRun = this.scheduleRuns[runIndex + 1];

        if ((this.selectedRodeoEvent.reverseSecondRound || this.selectedRodeoEvent.reverseSecondRoundDragOnly) && this.selectedRound == 2) {
            nextRun = run;
            run = this.scheduleRuns[runIndex + 1]
        }

        let lastDragCount = 0;
        let currentDragCount = 0;

        lastDragCount = Math.floor(+run.number / +this.selectedRodeoEvent.dragEvery);
        currentDragCount = Math.floor(+nextRun.number / +this.selectedRodeoEvent.dragEvery);

        if ((currentDragCount > lastDragCount && +nextRun.number % +this.selectedRodeoEvent.dragEvery != 0) || +run.number % +this.selectedRodeoEvent.dragEvery == 0)
            return true;

        return false;
    }

    shouldWriteBigDragLine(run, runIndex) {
        if (this.selectedRodeoEvent.dragEvery == 0 || run == null || runIndex + 1 >= this.scheduleRuns.length)
            return false;

        let nextRun = this.scheduleRuns[runIndex + 1];

        if ((this.selectedRodeoEvent.reverseSecondRound && !this.selectedRodeoEvent.reverseSecondRoundDragOnly) && this.selectedRound == 2) {
            nextRun = run;
            run = this.scheduleRuns[runIndex + 1]
        }

        let lastBigDragCount = Math.floor((+run.number - 1) / +this.selectedRodeoEvent.bigDragEvery);
        let currentBigDragCount = Math.floor((+nextRun.number - 1) / +this.selectedRodeoEvent.bigDragEvery);

        if (currentBigDragCount > lastBigDragCount && +nextRun.number % +this.selectedRodeoEvent.bigDragEvery != 0)
            return true;

        return false;
    }

    openJudgeScores() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        let entryModal = this.modalCtrl.create(JudgeScoresPage, { rodeo: this.rodeo, runId: this.selectedRun.id, selectedRodeoEvent: this.selectedRodeoEvent }, { cssClass: 'page-judge-scores', enableBackdropDismiss: true });

        entryModal.present().then(() => {
            this.popoverActive = false;
        })
    }

    matchRounds(a: string, b: string) {
        return a == b;
    }

    matchSchedules(a: any, b: any) {
        return a.name.toLowerCase().trim() == b.name.toLowerCase().trim();
    }

    changedSchedule() {
        this.possibleRodeoEvents = [];
        this._rodeo.rodeoEvents.forEach(rodeoEvent => {
            let schedule = rodeoEvent.schedules.filter(x => x.name === this.selectedSchedule.name)[0];

            if (schedule) {
                if (!this.selectedRodeoEvent) {
                    this.selectedRodeoEvent = rodeoEvent;

                    if (this.selectedRound >= this.selectedRodeoEvent.rounds)
                        this.selectedRound = this.selectedRodeoEvent.rounds;

                    this.roundArray = [];

                    for (let i = 1; i <= this.selectedRodeoEvent.rounds + (this.selectedRodeoEvent.shortGo ? 1 : 0); i++) {
                        this.roundArray.push(i);
                    }

                    this.leaderModes = this.rodeo.payoutConfigs.filter(x => x.sources.some(y => y.rodeoEventId == this.selectedRodeoEvent.id && (!y.scheduleId || y.scheduleId == this.selectedSchedule.id)));
                }

                this.possibleRodeoEvents.push(rodeoEvent);

                if (this.selectedRodeoEvent == rodeoEvent) {
                    this.selectedSchedule = schedule;
                }
            }
        });

        if (this.possibleRodeoEvents.indexOf(this.selectedRodeoEvent) == -1) {
            this.selectedRodeoEvent = this.possibleRodeoEvents[0];
            this.selectedSchedule = this.selectedRodeoEvent.schedules.filter(x => x.name === this.selectedSchedule.name)[0];
        }

        if (!this.displayRun)
            this.displayRun = new RodeoEventRun();

        this.changeSelectedRodeoEvent();

        this.selectedRun = this.scheduleRuns[0];
        this.setDisplayRun(this.scheduleRuns[0]);
    }

    getEntryCount(rodeoEvent: RodeoEvent, schedule: RodeoEventSchedule) {
        return rodeoEvent.registrations.filter(x => x.scheduleIds[0] == schedule.id).length;
    }

    setDisplayValue(rodeoEvent: RodeoEvent, run: RodeoEventRun) {
        if (!run)
            return;

        if (run.noTime)
            run.displayValue = rodeoEvent.configuration.runs.scoreValue ? "NS" : "NT";
        else {
            if (rodeoEvent.configuration.runs.scoreValue) {
                run.displayValue = run.score;
            }

            if (rodeoEvent.configuration.runs.timeValue) {
                var timeString = run.time.toString();
                var periodIndex = timeString.indexOf(".");

                if (periodIndex == -1)
                    timeString += ".";

                let zeroCount = timeString.length - 1 - timeString.indexOf(".");
                let decimalPlaces = 3;

                if (rodeoEvent.eventType.indexOf('Barrel') == -1 && rodeoEvent.eventType.indexOf('Bending') == -1)
                    decimalPlaces--;

                if (rodeoEvent.eventType.indexOf('Wrestling') != -1)
                    decimalPlaces--;

                while (decimalPlaces - zeroCount > 0) {
                    timeString += "0";
                    zeroCount++;
                }

                if (zeroCount > decimalPlaces) {
                    timeString = timeString.toString().substring(0, periodIndex + 3);
                }

                if (rodeoEvent.configuration.runs.scoreValue) {
                    run.timeDisplayValue = timeString;
                } else
                    run.displayValue = timeString;
            }
        }
    }

    toggleTurnout() {
        if (this.selectedRun.turnedOut) {
            this.selectedRun.turnedOut = false;
        } else {
            this.selectedRun.turnedOut = true;
            this.selectedRun.done = true;
        }

        var scheduleToUpdate = this.rodeo.rodeoEvents.flatMap(x => x.schedules).filter(x => x.id == this.selectedRun.rodeoEventScheduleId)[0];
        let runIndex = scheduleToUpdate.runs.indexOf(scheduleToUpdate.runs.filter(x => x.id == this.selectedRun.id)[0]);
        let scheduleRunsIndex = this.scheduleRuns.indexOf(scheduleToUpdate.runs.filter(x => x.id == this.selectedRun.id)[0]);

        this.runService.updateRuns([this.selectedRun])
            .then((data) => {
                if (!data)
                    console.log("updateRuns error: ", data);
                else if ((data as any).message !== undefined)
                    this.alertMessager.showError("Update Error", (data as any).message);
                else {
                    this.setDisplayValue(this.selectedRodeoEvent, data[0]);

                    scheduleToUpdate.runs[runIndex] = data[0] as RodeoEventRun;
                    scheduleToUpdate.runs[runIndex].edited = false;
                    scheduleToUpdate.runs[runIndex].saving = false;

                    this.scheduleRuns[scheduleRunsIndex] = data[0] as RodeoEventRun;
                    this.scheduleRuns[scheduleRunsIndex].edited = false;
                    this.scheduleRuns[scheduleRunsIndex].saving = false;

                    if (this.selectedRun.turnedOut) {
                        setTimeout(() => {
                            this.nextRun();
                        }, 250);
                    } else {
                        this.timerTime = "0";
                        this.timerScore = "0";
                        this.selectRun(this.selectedRun, false, true);
                    }

                    this.updateLeaders();
                    this.scheduleRunsLeft = this.scheduleRuns.filter(x => !x.done).length;
                }
            }, error => {
                scheduleToUpdate.runs[runIndex].error = true;
                scheduleToUpdate.runs[runIndex].saving = false;

                this.scheduleRuns[scheduleRunsIndex].saving = false;
                this.scheduleRuns[scheduleRunsIndex].error = true;
            });
    }

    showRodeoEventLeaders(rodeoEvent: RodeoEvent) {
        this.castingRodeoEvent = rodeoEvent;

        this.updateLeaders();
    }

    getPenaltyMessage(run) {
        var message = this.selectedRodeoEvent.eventType.indexOf('Barrel') != -1 ? ' Barrel' : ' Pole';
        var count = +(run.penaltyTime / this.selectedRodeoEvent.barrelPenalty).toFixed(0);

        if (count > 1)
            return count + message + "s";
        else
            return count + message;
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    noTime() {
        this.updateSelectedRun(this.selectedRun.noTime, false, false, 0);
    }

    oneLeg() {
        this.selectedRun.oneLeg = !this.selectedRun.oneLeg;

        var penaltyTimeAdjustment = this.selectedRun.oneLeg ? 5 : -5;
        this.selectedRun.penaltyTime = +this.selectedRun.penaltyTime + penaltyTimeAdjustment;

        this.updateSelectedRun(false, false, true, penaltyTimeAdjustment);
    }

    scatchStock(run) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(StockSwapPage, {
            rodeo: this._rodeo,
            rodeoEvent: this.selectedRodeoEvent,
            run: run
        }, {
            cssClass: 'stock-swap'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;
        });
    }

    barrier() {
        this.selectedRun.barrierOneBreak = !this.selectedRun.barrierOneBreak;

        var penaltyTimeAdjustment = this.selectedRun.barrierOneBreak ? +this.selectedRodeoEvent.barrierPenalty : -this.selectedRodeoEvent.barrierPenalty;
        this.selectedRun.penaltyTime = +this.selectedRun.penaltyTime + penaltyTimeAdjustment;

        this.updateSelectedRun(false, false, true, penaltyTimeAdjustment);
    }

    barrierAndLeg() {
        var wasLeg = this.selectedRun.oneLeg;
        var wasbarrierOneBreak = this.selectedRun.barrierOneBreak;
        var wasBoth = wasLeg && wasbarrierOneBreak;

        if (wasBoth) {
            this.selectedRun.oneLeg = false;
            this.selectedRun.barrierOneBreak = false;
        } else {
            this.selectedRun.oneLeg = true;
            this.selectedRun.barrierOneBreak = true;
        }

        var penaltyTimeAdjustment = wasLeg ? (this.selectedRun.oneLeg ? 0 : -5) : (this.selectedRun.oneLeg ? 5 : 0);
        penaltyTimeAdjustment += wasbarrierOneBreak ? (this.selectedRun.barrierOneBreak ? 0 : -this.selectedRodeoEvent.barrierPenalty) : (this.selectedRun.barrierOneBreak ? +this.selectedRodeoEvent.barrierPenalty : 0);

        this.selectedRun.penaltyTime = +this.selectedRun.penaltyTime + penaltyTimeAdjustment;

        this.updateSelectedRun(false, false, true, penaltyTimeAdjustment);
    }

    crossfire() {
        this.selectedRun.crossfire = !this.selectedRun.crossfire;

        if (this.selectedRodeoEvent.crossfireTimePenalty > 0) {
            var penaltyTimeAdjustment = this.selectedRun.crossfire
                ? +this.selectedRodeoEvent.crossfireTimePenalty
                : -this.selectedRodeoEvent.crossfireTimePenalty;
            this.selectedRun.penaltyTime =
                +this.selectedRun.penaltyTime + penaltyTimeAdjustment;

            this.updateSelectedRun(false, false, true, penaltyTimeAdjustment);
        } else if (this.selectedRodeoEvent.crossfireTimePenalty === 0) {
            this.selectedRun.noTime = !this.selectedRun.noTime;
            this.updateSelectedRun(!this.selectedRun.crossfire, false, false, 0);
        }
    }

    penalty(time, count) {
        let newPenaltyTime = time * 1 * count * 1;
        let penaltyTimeAdjustment = 0;

        penaltyTimeAdjustment = newPenaltyTime == +this.selectedRun.penaltyTime ? -newPenaltyTime : +newPenaltyTime - +this.selectedRun.penaltyTime;

        this.selectedRun.penaltyTime = +this.selectedRun.penaltyTime + penaltyTimeAdjustment;

        this.updateSelectedRun(false, false, true, penaltyTimeAdjustment);
    }

    headerMiss() {
        this.selectedRun.headerMiss = !this.selectedRun.headerMiss;
        this.updateSelectedRun(!this.selectedRun.headerMiss, false, false, 0);
    }

    heelerMiss() {
        this.selectedRun.heelerMiss = !this.selectedRun.heelerMiss;
        this.updateSelectedRun(!this.selectedRun.heelerMiss, false, false, 0);
    }

    rerun() {
        this.updateSelectedRun(false, true, false, 0);
    }

    clean() {
        if (this.selectedRun.done || (this.selectedRodeoEvent.configuration.runs.scoreValue != this.selectedRodeoEvent.configuration.runs.timeValue && this.displayRun.displayValue == 0))
            return;

        if (this.selectedRodeoEvent.configuration.runs.scoreValue && this.selectedRodeoEvent.configuration.runs.timeValue && this.displayRun.timeDisplayValue == 0)
            return;

        this.updateSelectedRun(true, false, false, 0);
    }

    updateSelectedRun(clean, rerun, penalty, penaltyTimeAdjustment) {
        var scheduleToUpdate = this.rodeo.rodeoEvents.flatMap(x => x.schedules).filter(x => x.id == this.selectedRun.rodeoEventScheduleId)[0];
        let runIndex = scheduleToUpdate.runs.indexOf(scheduleToUpdate.runs.filter(x => x.id == this.selectedRun.id)[0]);
        let scheduleRunsIndex = this.scheduleRuns.indexOf(scheduleToUpdate.runs.filter(x => x.id == this.selectedRun.id)[0]);

        this.selectedRun.saving = true;
        this.selectedRun.done = true;

        let wasNoTime = this.selectedRun.noTime && (clean || rerun || penalty);

        if (rerun) {
            this.selectedRun.noTime = false;
            this.selectedRun.done = false;
            this.selectedRun.time = 0;
            this.selectedRun.penaltyTime = 0;
            this.selectedRun.oneLeg = false;
            this.selectedRun.barrierOneBreak = false;
            this.selectedRun.barrierTwoBreak = false;
            this.selectedRun.knockdownBarrelOne = false;
            this.selectedRun.knockdownBarrelTwo = false;
            this.selectedRun.knockdownBarrelThree = false;
            this.selectedRun.headerSplit = 0;
            this.selectedRun.heelerSplit = 0;
            this.selectedRun.breakoutTime = 0;
            this.selectedRun.score = 0;
            this.selectedRun.displayValue = 0;
            this.selectedRun.timeDisplayValue = 0;
            this.selectedRun.totalTime = 0;
            this.selectedRun.totalScore = 0;
            this.selectedRun.disqualified = false;

            this.selectRun(this.selectedRun, false, false);
        } else if (clean) {
            this.selectedRun.noTime = false;
            this.selectedRun.penaltyTime = 0;

            if (this.selectedRodeoEvent.configuration.runs.scoreValue) {
                this.selectedRun.score = (wasNoTime ? this.displayRun.score * 1 : this.displayRun.displayValue * 1).toFixed(2);
                this.selectedRun.time = (wasNoTime ? this.displayRun.time * 1 : this.displayRun.timeDisplayValue * 1).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
            }
            else
                this.selectedRun.time = (wasNoTime ? this.displayRun.time * 1 : this.displayRun.displayValue * 1).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);

            this.selectedRun.totalTime = +(this.selectedRun.startingTime * 1 + this.selectedRun.time * 1).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
            this.selectedRun.totalScore = +(this.selectedRun.startingScore * 1 + this.selectedRun.score * 1).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
            this.setDisplayValue(this.selectedRodeoEvent, this.selectedRun);
        } else if (penalty) {
            if (this.judgeConfig) {
                if (this.selectedRodeoEvent.configuration.runs.scoreValue)
                    this.displayRun.timeDisplayValue = +this.displayRun.timeDisplayValue + penaltyTimeAdjustment;
                else
                    this.displayRun.displayValue = +this.displayRun.displayValue + penaltyTimeAdjustment;
            } else {
                if (!this.selectedRodeoEvent.configuration.runs.scoreValue)
                    this.displayRun.displayValue = +this.displayRun.displayValue + penaltyTimeAdjustment;
            }

            this.selectedRun.noTime = false;

            if (this.selectedRodeoEvent.configuration.runs.scoreValue) {
                this.selectedRun.score = (this.displayRun.displayValue * 1 - penaltyTimeAdjustment).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
                this.selectedRun.time = (+this.displayRun.timeDisplayValue).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
            }
            else
                this.selectedRun.time = (this.displayRun.displayValue * 1).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);

            this.selectedRun.totalTime = +(this.selectedRun.startingTime * 1 + this.selectedRun.time * 1).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
            this.selectedRun.totalScore = +(this.selectedRun.startingScore * 1 + this.selectedRun.score * 1).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
            this.setDisplayValue(this.selectedRodeoEvent, this.selectedRun);
        } else {
            this.selectedRun.noTime = true;

            if (this.selectedRodeoEvent.configuration.runs.scoreValue) {
                this.selectedRun.time = (this.displayRun.timeDisplayValue * 1).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
                this.selectedRun.score = (this.displayRun.displayValue * 1).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
                this.selectedRun.totalScore = this.selectedRun.startingScore;
            }
            else
                this.selectedRun.time = (this.displayRun.displayValue * 1).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);

            this.selectedRun.totalTime = this.selectedRun.startingTime;
        }

        if (this.disqualified && this.disqualified[this.selectedRun.id] && this.disqualified[this.selectedRun.id].some(x => x == 1)) {
            this.selectedRun.noTime = true;
            this.selectedRun.disqualified = true;
        }

        this.runService.updateRuns([this.selectedRun])
            .then((data) => {
                if ((data as any).message !== undefined) {
                    this.alertMessager.showError("Update Error", (data as any).message);
                    scheduleToUpdate.runs[runIndex].error = true;
                } else {
                    setTimeout(() => {
                        this.updateTimerSelectedRun(data[0]);
                    }, 0);

                    this.setDisplayValue(this.selectedRodeoEvent, data[0]);

                    scheduleToUpdate.runs[runIndex] = data[0] as RodeoEventRun;
                    scheduleToUpdate.runs[runIndex].error = false;
                    scheduleToUpdate.runs[runIndex].edited = false;
                    scheduleToUpdate.runs[runIndex].saving = false;

                    this.scheduleRuns[scheduleRunsIndex] = data[0] as RodeoEventRun;
                    this.scheduleRuns[scheduleRunsIndex].edited = false;
                    this.scheduleRuns[scheduleRunsIndex].saving = false;

                    if (!rerun && !wasNoTime) {
                        setTimeout(() => {
                            this.nextRun();
                        }, 350);
                    } else {
                        this.selectRun(this.selectedRun, true, true);
                    }

                    this.updateLeaders();
                    this.scheduleRunsLeft = this.scheduleRuns.filter(x => !x.done).length;
                }
            }, error => {
                scheduleToUpdate.runs[runIndex].error = true;
                scheduleToUpdate.runs[runIndex].saving = false;

                this.scheduleRuns[scheduleRunsIndex].saving = false;
                this.scheduleRuns[scheduleRunsIndex].error = true;
            });

        if (this.castingRodeoEvent.id != this.selectedRodeoEvent.id)
            this.castingRodeoEvent = this.selectedRodeoEvent;

        this.updateLeaders();
    }

    nextRun() {
        let runIndex = this.scheduleRuns.indexOf(this.scheduleRuns.filter(x => x.id == this.selectedRun.id)[0]);

        this.timerTime = "0";
        this.timerScore = "0";

        if (this.scheduleRuns[runIndex + 1]) {
            this.selectRun(this.scheduleRuns[runIndex + 1], true, false);
        }
    }

    prevRun() {
        let runIndex = this.scheduleRuns.indexOf(this.scheduleRuns.filter(x => x.id == this.selectedRun.id)[0]);

        this.timerTime = "0";
        this.timerScore = "0";

        if (runIndex > 0 && this.scheduleRuns[runIndex - 1]) {
            this.selectRun(this.scheduleRuns[runIndex - 1], this.selectedRun.noTime, false);
        }
    }

    updateTimerSelectedRun(run: RodeoEventRun) {
        if (this.selectedRodeoEvent.nominationId && this.selectedRodeoEvent.nominationId > 0) {
            if (run.horseOne) {
                run.horseOne.isNominated = run.horseOne.nominations.some(x => x.status == 'Active' && x.nominationId == this.selectedRodeoEvent.nominationId);
            }

            if (run.horseTwo) {
                run.horseTwo.isNominated = run.horseTwo.nominations.some(x => x.status == 'Active' && x.nominationId == this.selectedRodeoEvent.nominationId);
            }
        }

        var timerRun = JSON.parse(JSON.stringify(run));

        if (this.judgeConfig && this.judgeConfig.judges.length == 2) {
            this.judgeConfig.categories.forEach(category => {
                if (category.penalty)
                    return;

                if (category.category == 'Rider') {
                    timerRun.judgeOneRiderScore = this.getJudgeScore(this.judgeConfig.judges[0], category, run.id);
                    timerRun.judgeTwoRiderScore = this.getJudgeScore(this.judgeConfig.judges[1], category, run.id);
                } else if (category.category == 'Animal') {
                    timerRun.judgeOneStockScore = this.getJudgeScore(this.judgeConfig.judges[0], category, run.id);
                    timerRun.judgeTwoStockScore = this.getJudgeScore(this.judgeConfig.judges[0], category, run.id);
                }
            });

            timerRun.athleteScore = +timerRun.judgeOneRiderScore + +timerRun.judgeTwoRiderScore;
            timerRun.stockScore = +timerRun.judgeOneStockScore + +timerRun.judgeTwoStockScore;
        }

        this.timerService.setSelectedRun(this.timerUrl, timerRun, this.selectedRodeoEvent.displayName, this.selectedRodeoEvent.eventType.indexOf('Barrel') != -1)
            .then(data => {
                this.timerErrorMessage = null;
            },
                error => {
                    this.timerErrorMessage = error;
                });

        this.timerService.setOnlineSelectedRun(run, this.rodeo.id)
            .then(data => {
                this.timerErrorMessage = null;
            },
                error => {
                    this.timerErrorMessage = error;
                });
    }

    getJudges() {
        this.judgeService.getScoresForRodeoEvent(this.rodeo.id, this.selectedRodeoEvent.id)
            .then(judgeConfig => {
                if (judgeConfig && judgeConfig.judges && judgeConfig.judges.length > 0) {
                    const scoreHash = {};
                    this.disqualified = [];
                    var allRunIds = [];

                    this.judgeConfig = judgeConfig;
                    this.judgeConfig.judges.forEach((judge, index) => {
                        const scoresHash = [];
                        judge.scores.forEach(score => {
                            if (!this.disqualified[score.runId])
                                this.disqualified[score.runId] = [];

                            if (score.disqualify)
                                this.disqualified[score.runId][index] = 1;

                            if (!scoresHash[score.runId]) {
                                scoresHash[score.runId] = {
                                    total: this.selectedRodeoEvent.baseJudgeScore,
                                    scores: []
                                }
                            }

                            if (allRunIds.filter(x => x == score.runId).length == 0) {
                                allRunIds.push(score.runId);
                            }

                            scoresHash[score.runId].total += score.score;
                            scoresHash[score.runId].scores.push(score);

                            // Second hash?
                            if (!scoreHash[score.runId]) {
                                scoreHash[score.runId] = {
                                    totals: {
                                        total: this.selectedRodeoEvent.baseJudgeScore * this.judgeConfig.judges.length,
                                    }
                                }
                            }

                            scoreHash[score.runId].totals.total += score.score;

                            if (!scoreHash[score.runId].totals[score.category]) {
                                scoreHash[score.runId].totals[score.category] = 0;
                            }

                            scoreHash[score.runId].totals[score.category] += score.score;
                        });

                        judge.scoresHash = scoresHash;
                    });

                    var judgeCount = this.judgeConfig.judges.length;

                    if (this.selectedRodeoEvent.dropHighLowJudgeScores && judgeCount > 2) {
                        judgeCount -= 2;

                        allRunIds.forEach(runId => {
                            var lowestScore = 1000000;
                            var highestScore = 0;

                            this.judgeConfig.judges.map(x => x.scoresHash).forEach(judgeScoreHash => {
                                if (!judgeScoreHash[runId])
                                    return;

                                if (judgeScoreHash[runId].total < lowestScore)
                                    lowestScore = judgeScoreHash[runId].total;

                                if (judgeScoreHash[runId].total > highestScore)
                                    highestScore = judgeScoreHash[runId].total;
                            });

                            scoreHash[runId].totals.total -= lowestScore;
                            scoreHash[runId].totals.total -= highestScore;
                        });
                    }

                    if (this.selectedRodeoEvent.averageJudgeTotalScores) {
                        Object.keys(scoreHash).forEach(runId => {
                            Object.keys(scoreHash[runId].totals).forEach(key => {
                                if (key == 'total') {
                                    scoreHash[runId].totals.total = (scoreHash[runId].totals.total / judgeCount).toFixed(2);
                                }
                            });
                        });
                    }
                    this.judgeConfig.scoresHash = scoreHash;

                    if (this.displayRun && scoreHash[this.displayRun.id]) {
                        if (this.selectedRodeoEvent.configuration.runs.scoreValue) {
                            if (this.selectedRodeoEvent.configuration.runs.timeValue)
                                this.displayRun.displayValue = +(+scoreHash[this.displayRun.id].totals.total + +this.selectedRodeoEvent.showBaseTime - +this.displayRun.timeDisplayValue).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
                            else
                                this.displayRun.displayValue = +(+scoreHash[this.displayRun.id].totals.total).toFixed(this.selectedRodeoEvent.configuration.runs.decimalPlaces);
                        }

                        this.updateTimerSelectedRun(this.displayRun);
                    } else {
                        this.displayRun.displayFieldOne = '';
                    }
                } else {
                    this.judgeConfig = null;
                }

                setTimeout(() => {
                    this.getJudges();
                }, 250);
            }, error => {
                setTimeout(() => {
                    this.getJudges();
                }, 500);
            });
    }

    getJudgeScore(judge: Judge, category: JudgeCategory, runId: number) {
        const judgeScores = judge.scoresHash ? judge.scoresHash[runId] : null;
        if (judgeScores) {
            const score = judgeScores.scores.find(x => x.category == category.category);
            return score ? score.score : 0;
        }
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (this.elementRef.nativeElement.hidden || !this.selectedRun)
            return;

        if (ev.key === "ArrowDown") {
            this.nextRun();
        } else if (ev.key === "ArrowUp") {
            this.prevRun();
        }

        if (this.announcerMode)
            return;

        const lowerCaseKey = ev.key.toLocaleLowerCase();

        if (lowerCaseKey === "enter") {
            this.clean();
        } else if (lowerCaseKey === "r") {
            this.rerun();
        } else if (lowerCaseKey === "i") {
            this.penalty(this.selectedRodeoEvent.barrelPenalty, 1);
        } else if (lowerCaseKey === "o") {
            this.penalty(this.selectedRodeoEvent.barrelPenalty, 2);
        } else if (lowerCaseKey === "p" && (this.selectedRodeoEvent.eventType == 'PoleBending' || this.selectedRodeoEvent.eventType == 'BarrelRacing')) {
            this.penalty(this.selectedRodeoEvent.barrelPenalty, 3);
        } else if (lowerCaseKey === "k") {
            this.penalty(this.selectedRodeoEvent.barrelPenalty, 4);
        } else if (lowerCaseKey === "l" && this.selectedRodeoEvent.eventType == 'PoleBending') {
            this.penalty(this.selectedRodeoEvent.barrelPenalty, 5);
        } else if (lowerCaseKey === ";") {
            this.penalty(this.selectedRodeoEvent.barrelPenalty, 6);
        } else if (lowerCaseKey === "l" && (this.selectedRodeoEvent.eventType == 'TeamRoping' || this.selectedRodeoEvent.eventType == 'ShowTeamRoping')) {
            this.oneLeg();
        } else if (lowerCaseKey === "b") {
            this.barrier();
        } else if (lowerCaseKey === "n") {
            this.noTime()
        } else if (lowerCaseKey === "f" && (this.selectedRodeoEvent.eventType == 'TeamRoping' || this.selectedRodeoEvent.eventType == 'ShowTeamRoping')) {
            this.heelerMiss()
        } else if (lowerCaseKey === "h" && (this.selectedRodeoEvent.eventType == 'TeamRoping' || this.selectedRodeoEvent.eventType == 'ShowTeamRoping')) {
            this.headerMiss()
        } else if (lowerCaseKey === "t") {
            this.toggleTurnout();
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/scoring/scoring.ts